// API Configuration
export const API_BASE_URL = 'https://ughs-qpg.onrender.com';
// For local development:
// export const API_BASE_URL = 'http://127.0.0.1:8000';
